import Model from './Model'
export default class Workstation extends Model {

    baseURL() {
        return `${window.App.api_endpoint}/api`
    }

    resource()
    {
        return 'workstations'
    }

    get vat_no() {
        return this.data?.vat_no
    }

    get full_address() {
        return `${this.data.address} ${this.data.address_no}, ${this.data.city}`
    }
}
